import { Callout } from '@vp/swan'
import type { NavigationBadge } from '../../types/navigation'

export const Badge = ({ badge }: { badge?: NavigationBadge }) => {
  if (!badge) return null

  if (badge.treatment !== 'new') return null

  const emphasis = badge.skin === 'standard' ? 'standard' : 'low'
  const skin = badge.skin === 'standard' ? 'accent' : 'info'

  return (
    <Callout emphasis={emphasis} skin={skin} textAllCaps={badge.allCaps}>
      {badge.text + ` `}
    </Callout>
  )
}
